
import {mapMutations} from 'vuex'

export default {
	methods: {
		...mapMutations('Shared', {
			setToaster: 'SET_TOASTER'
		}),
		toaster(message, color, visible) {
			this.setToaster({
				message,
				color,
				visible
			})
		},
	}
}


// WEBPACK FOOTER //
// ./src/mixins/toaster.js